import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Faq: {
    id: 'label_faq_block',
    defaultMessage: 'FAQ block',
  },
  FaqHelp: {
    id: 'help_faq_block',
    defaultMessage:
      'Tick this if the accordion is used as a pure FAQ (titles = questions, texts = answers).',
  },
});
